module.exports = __webpack_public_path__ + "img/dataFile2.32eaf904.png";